import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Suspense, lazy, useEffect, useState } from "react";
import "../Menu.css";

// Lazy load the Counter component
const LazyCounter = lazy(() => import("./visitorcounter"));

// Lazy loading image component
const LazyImage = ({ src, alt, width, height, className, style }) => {
	const [imageSrc, setImageSrc] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		const img = new Image();
		img.src = src;
		img.onload = () => {
			setImageSrc(src);
			setIsLoaded(true);
		};
		img.onerror = () => {
			setHasError(true);
		};
	}, [src]);

	if (hasError) {
		return (
			<div
				style={{
					width,
					height,
					backgroundColor: "#f0f0f0",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					...style,
				}}
				className={className}>
				<span style={{ fontSize: "12px", color: "#666" }}>Image not found</span>
			</div>
		);
	}

	if (!isLoaded) {
		return (
			<div
				style={{
					width,
					height,
					backgroundColor: "#f0f0f0",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					...style,
				}}
				className={className}>
				<div className="loading-spinner"></div>
			</div>
		);
	}

	return (
		<img
			src={imageSrc}
			alt={alt}
			width={width}
			height={height}
			className={className}
			style={style}
			loading="lazy"
		/>
	);
};

// Reusable components
const SocialLink = ({ href, iconClass, target = "_blank" }) => (
	<li style={{ display: "inline-block", marginRight: "10px" }}>
		<a
			className="social-icon"
			href={href}
			target={target}
			rel="noopener noreferrer">
			<i className={iconClass} style={{ padding: "10px" }}></i>
		</a>
	</li>
);

const ContactItem = ({
	iconClass,
	iconStyle,
	title,
	content,
	href,
	onClick,
}) => (
	<div className="contact-item">
		<div className="my-icon" style={iconStyle}>
			<i className={iconClass} aria-hidden="true"></i>
		</div>
		<div className="content">
			<p>{title}</p>
			<h6>
				<a href={href} onClick={onClick} className="contact-link">
					{content}
				</a>
			</h6>
		</div>
	</div>
);

const QuickLink = ({ text, href, onClick }) => (
	<p
		style={{ marginBottom: "16px", cursor: "pointer" }}
		onClick={onClick || (() => (window.location.href = href))}
		className="quick-link">
		{text}
	</p>
);

const RecentPost = ({ imageSrc, title, date, href }) => (
	<div style={{ marginLeft: "-20px" }}>
		<div
			className="post-item"
			style={{
				display: "flex",
				alignItems: "flex-start",
				color: "white",
				marginTop: "10px",
			}}>
			<div className="post-img" style={{ marginRight: "10px" }}>
				<div
					onClick={() => (window.location.href = href)}
					className="post-img-link">
					<LazyImage width="80px" height="85px" src={imageSrc} alt={title} />
				</div>
			</div>
			<div className="post-text">
				<h6>
					<span
						onClick={() => (window.location.href = href)}
						className="recent-post-link">
						{title}
					</span>
				</h6>
				<div
					className="post-time"
					style={{ display: "flex", alignItems: "center" }}>
					<FontAwesomeIcon
						icon={faCalendar}
						style={{ color: "#006436", marginRight: "5px" }}
					/>
					<p style={{ margin: 0 }}>{date}</p>
				</div>
			</div>
		</div>
	</div>
);

// Footer section components
const FooterLeft = () => {
	const socialLinks = [
		{
			href: "https://www.facebook.com/profile.php?id=61552201433428",
			iconClass: "fa fa-facebook",
		},
		// { href: "https://twitter.com", iconClass: "fab fa-twitter" },
		{
			href: "https://www.youtube.com/@GlobalFoodStandards",
			iconClass: "fab fa-youtube",
		},
		{
			href: "https://www.instagram.com/globalfoodstandards/",
			iconClass: "fab fa-instagram",
		},
		// { href: "https://pinterest.com", iconClass: "fa fa-pinterest-p" },
		{
			href: "https://www.linkedin.com/in/global-academy-for-food-safety-and-sustainability-standards-46b472360/",
			iconClass: "fab fa-linkedin",
		},
	];

	return (
		<div className="footer-left">
			<div
				className="row"
				style={{ paddingBottom: "10px", alignItems: "center" }}>
				<div className="footer-logo">
					<a href="/">
						<LazyImage
							src="../images/FOOTER-LOGO.png"
							alt="logo"
							width="180px"
						/>
					</a>
				</div>
				<p>
					Global Academy for Food Safety and Sustainability Standards An
					initiative of Krishigap Digital Solutions Pvt. Ltd.
				</p>
			</div>
			<div className="social-link">
				<ul style={{ listStyle: "none", padding: 0 }}>
					{socialLinks.map((link, index) => (
						<SocialLink key={index} {...link} />
					))}
				</ul>
			</div>
		</div>
	);
};

const FooterContact = () => {
	const contactItems = [
		{
			iconClass: "fa fa-envelope-o",
			iconStyle: { padding: "0px 15px 0px 15px" },
			title: "Email",
			content: "info@krishigap.com",
			href: "mailto:info@krishigap.com",
		},
		{
			iconClass: "fa fa-map-marker",
			iconStyle: { padding: "5px 18px" },
			title: "Location",
			content:
				"House No 5-106/281B, Narsing Municipality, Manchirevula, K.V Ranga Reddy, Hyderabad, Telangana, 500075.",
			href: "#",
			onClick: (e) => e.preventDefault(),
		},
	];

	return (
		<div className="get-touch">
			<h4 className="footer__widget-title">Get in Touch</h4>
			{contactItems.map((item, index) => (
				<ContactItem key={index} {...item} />
			))}
		</div>
	);
};

const FooterQuickLinks = () => {
	const quickLinks = [
		{ text: "Instructor Led", href: "/instructorledlogin" },
		{ text: "Contact Us", href: "/contactus" },
		{ text: "Privacy Policy", href: "/privacypolicy" },
		{ text: "Terms & Conditions", href: "/termsconditions" },
		{ text: "Cancellation & Refund Policy", href: "/cancellationrefundpolicy" },
		{ text: "Disclaimer", href: "/disclaimer" },
	];

	return (
		<div className="footer__widget">
			<h4 className="footer__widget-title">Quick Links</h4>
			<div style={{ marginTop: "30px" }}>
				{quickLinks.map((link, index) => (
					<QuickLink key={index} {...link} />
				))}
			</div>
		</div>
	);
};

const FooterRecentPosts = () => {
	const recentPosts = [
		{
			imageSrc: "../images/recent-post-img.jpg",
			title: "Elevating your business to new heights",
			date: "May 14, 2023",
			href: "https://digitalvega.in/foodsafetyacademy/elevating-your-business-to-new-heights-3/",
		},
		{
			imageSrc: "../images/recent-post-img.jpg",
			title: "Elevating your business to new heights",
			date: "April 18, 2023",
			href: "https://digitalvega.in/foodsafetyacademy/elevating-your-business-to-new-heights/",
		},
		{
			imageSrc: "../images/recent-post-img-2.jpg",
			title: "Unleashing your business's full potential",
			date: "April 18, 2023",
			href: "https://digitalvega.in/foodsafetyacademy/unleashing-your-businesss-full-potential/",
		},
	];

	return (
		<div className="popular-post">
			<h4 className="footer__widget-title">Recent Post</h4>
			<ul>
				{recentPosts.map((post, index) => (
					<RecentPost key={index} {...post} />
				))}
			</ul>
		</div>
	);
};

// Main Footer component
const Footer = () => {
	const footerBackgroundStyle = {
		background: "#15222c",
		backgroundImage: 'url("../images/background-footer.png")',
		backgroundSize: "100%",
		color: "white",
		backgroundRepeat: "repeat-x",
		backgroundPosition: "center",
		position: "relative",
		zIndex: "1",
		height: "auto",
		width: "100%",
	};

	const secondFooterStyle = {
		background: "#15222c",
		backgroundImage: 'url("../images/background-footer.png")',
		backgroundSize: "cover",
		color: "white",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-end",
		alignItems: "center",
		position: "relative",
	};

	const footerMainStyle = {
		backgroundColor: "#14292D",
		height: "80px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
	};

	// Loading fallback for Counter component
	const CounterFallback = () => (
		<div style={{ textAlign: "center", padding: "10px", color: "white" }}>
			Loading...
		</div>
	);

	return (
		<footer>
			{/* First Footer Section */}
			<div style={footerBackgroundStyle}>
				<div className="info-footer v2">
					<div className="pl-pr-f container">
						<div className="row" style={{ justifyContent: "space-evenly" }}>
							<div className="col-lg-4 col-xl-3 col-md-8 col-sm-8">
								<FooterLeft />
							</div>
							<div className="col-lg-4 col-xl-3 col-md-8 col-sm-8 pt-f">
								<FooterQuickLinks />
							</div>
							<div className="col-lg-4 col-xl-3 col-md-8 col-sm-8 pt-f">
								<FooterContact />
							</div>
						</div>
					</div>
					<Suspense fallback={<CounterFallback />}>
						<LazyCounter />
					</Suspense>
				</div>
			</div>

			{/* Second Footer Section with repeated background */}
			<div style={secondFooterStyle}>
				<div className="footer-main" style={footerMainStyle}>
					<p style={{ color: "#838F91", margin: 0 }}>
						Copyright © {new Date().getFullYear()} Global Academy For Food
						Safety And Sustainability Standards. All Rights Reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
